<div class="prospect_top_sec">
    <h5 class="prospectsHeader" i18n="@@FollowUps">Follow-Ups</h5>
</div>
<form class="w-100 d-block" [formGroup]="followUpForm" (ngSubmit)="saveFollowups()" novalidate>
    <div class="row w-100 mx-0">
        <app-call-script [section]="section" style="width: 100%;"></app-call-script>
    </div>
    <div class="row mt-3">
        
        <div class="col-md-6 form-group">

            <label i18n="@@AssignedTo">Assigned To
                <span class="required" *ngIf="followUpForm.get('AssignedTo').validator !== null">*</span>
            </label>
            <ejs-dropdownlist #grouping id='assignedTo' [dataSource]='assignedToList' [placeholder]='groupWaterMark'
                [fields]='groupFields' [popupHeight]='height' formControlName="AssignedTo" [enabled]="false"
                appHighlightCallScriptFields [fieldName]="'AssignedTo'" [linkedFieldsList]="callScriptFields">
            </ejs-dropdownlist>
            <div class="alert alert-danger" *ngIf="followUpForm.get('AssignedTo').errors !== null && 
            (followUpForm.get('AssignedTo').dirty || followUpForm.get('AssignedTo').touched) &&
            followUpForm.get('AssignedTo').validator !== null">
                <span *ngIf="followUpForm.get('AssignedTo').errors.required">AssignedTo is required</span>
            </div>
        </div>
        <div class="col-md-6 form-group">
            <label i18n="@@Priority">Priority
                <span class="required" *ngIf="followUpForm.get('Priority').validator !== null">*</span>
            </label>
            <select class="form-control" formControlName="Priority" appHighlightCallScriptFields
                [fieldName]="'Priority'" [linkedFieldsList]="callScriptFields">
                <option [value]="item.Id" *ngFor="let item of priorityList">{{item.Name}}</option>
            </select>
            <div class="alert alert-danger" *ngIf="followUpForm.get('Priority').errors !== null && 
            (followUpForm.get('Priority').dirty || followUpForm.get('Priority').touched) &&
            followUpForm.get('Priority').validator !== null">
                <span *ngIf="followUpForm.get('Priority').errors.required">Priority is required</span>
            </div>
        </div>
        <div class="col-md-6 form-group">
            <label i18n="@@FollowUpAction">Follow-Up Action
                <span class="required" *ngIf="followUpForm.get('FollowUpAction').validator !== null">*</span>
            </label>
            <select class="form-control" formControlName="FollowUpAction" disabled appHighlightCallScriptFields
                [fieldName]="'FollowUpAction'" [linkedFieldsList]="callScriptFields">
                <option [value]="item.Id" *ngFor="let item of followUpActionList">{{item.Name}}
                </option>
            </select>
            <div class="alert alert-danger" *ngIf="followUpForm.get('FollowUpAction').errors !== null && 
            (followUpForm.get('FollowUpAction').dirty || followUpForm.get('FollowUpAction').touched) &&
            followUpForm.get('FollowUpAction').validator !== null">
                <span *ngIf="followUpForm.get('FollowUpAction').errors.required">FollowUp Action is required</span>
            </div>
        </div>
        <div class="col-md-6 form-group">
            <label i18n="@@FollowUpDate">Follow-Up Date
                <span class="required" *ngIf="followUpForm.get('FollowUpDate').validator !== null">*</span>
            </label>
            <ejs-datepicker class="form-control p-0 h-auto" required name="date" format='MM/dd/yyyy' floatLabelType='Always'
                formControlName="FollowUpDate" [enabled]="false" appHighlightCallScriptFields
                [fieldName]="'FollowUpDate'" [linkedFieldsList]="callScriptFields">
            </ejs-datepicker>
            <div class="alert alert-danger" *ngIf="followUpForm.get('FollowUpDate').errors !== null && 
            (followUpForm.get('FollowUpDate').dirty || followUpForm.get('FollowUpDate').touched) &&
            followUpForm.get('FollowUpDate').validator !== null">
                <span *ngIf="followUpForm.get('FollowUpDate').errors.required">FollowUp Date is required</span>
            </div>
        </div>
        <div class="col-md-6 form-group">
            <label i18n="@@Notes">Notes
                <span class="required" *ngIf="followUpForm.get('Notes').validator">*</span>
            </label>
            <textarea class="form-control" rows="5" formControlName="Notes" appHighlightCallScriptFields
                [fieldName]="'Notes'" [linkedFieldsList]="callScriptFields"></textarea>
            <div class="alert alert-danger" *ngIf="followUpForm.get('Notes').errors !== null && 
                (followUpForm.get('Notes').dirty || followUpForm.get('Notes').touched)">
                <span *ngIf="followUpForm.get('Notes').errors.required">Notes is required</span>
                <span *ngIf="followUpForm.get('Notes').errors.whitespace"> Invalid
                    input </span>
            </div>
        </div>
    </div>


    <div class="row mx-0 mt-3" *ngIf="followUpNotesList && followUpNotesList.length">
        <ejs-tooltip #tooltip position='BottomCenter' target=".e-rowcell.customcss">
            <ejs-grid #grid1 [dataSource]='followUpNotesList' class="Table_Height_pros_one table-striped " height='200'
                allowSorting='true' (mouseover)='mouseover($event)'>
                <e-columns>

                    <e-column field='Name' headerText='Name' width='50' textAlign='Left'>
                        <ng-template #template let-data>
                            <span class="dataName">{{data.Name}}</span>
                        </ng-template>
                    </e-column>

                    <e-column field='AssignedTo' headerText='Assigned To' width='50' textAlign='Left'>
                        <ng-template #template let-data>
                            <span class="dataName">{{data.AssignedUser}}</span>
                        </ng-template>
                    </e-column>

                    <e-column field='Priority' headerText='Priority' width='50' textAlign='Left'>
                        <ng-template #template let-data>
                            <span class="dataName">{{data.PriorityName}}</span>
                        </ng-template>
                    </e-column>

                    <e-column field='FollowUpAction' headerText='Follow-Up Action' width='50' textAlign='Left'>
                        <ng-template #template let-data>
                            <span class="dataName">{{data.FollowUpActionName}}</span>
                        </ng-template>
                    </e-column>

                    <e-column field='FollowUpDate' headerText='Follow-Up Date' width='50' textAlign='Left'>
                        <ng-template #template let-data>
                            <span class="dataName">{{data.FollowUpDate | date: 'MM/dd/yyyy'}}</span>
                        </ng-template>
                    </e-column>

                    <e-column field='Notes' headerText='Notes' width='50' textAlign='Left'
                        [customAttributes]='customAttri'>
                        <ng-template #template let-data>
                            <span class="dataName">{{data.Notes}}</span>
                        </ng-template>
                    </e-column>

                </e-columns>
            </ejs-grid>
        </ejs-tooltip>
    </div>
    <div class="bottom_button mt-3">
        <button type="button" class="btn btn-outline-primary me-3" i18n="@@Cancel"
            (click)="openCancel()">Cancel</button>
        <button type="submit" class="btn btn-primary" i18n="@@Save"
            [disabled]="!followUpForm.valid || !editRight">Save</button>
        <div class="button_tooltip_modal" *ngIf="!editRight">
            <p class="mb-0" *ngIf="!editRight">{{editRightFalseMessage}}</p>
            <i class="fa fa-caret-down .text-dark h2 butt_downIcon" aria-hidden="true"></i>
        </div>
    </div>
</form>